import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.permissionMgmtController;
const getPermissionMgmt = self.customSetting.getPermissionMgmt;
const postPermissionMgmt = self.customSetting.postPermissionMgmt;

export default {
  qryMenu: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getPermissionMgmt}/QryMenu`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  appendMenu: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/AppendMenu`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  editMenu: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/EditMenu`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  deleteMenu: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/DeleteMenu`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryGroupFun: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getPermissionMgmt}/QryGroupFun`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insGroupFun: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/InsGroupFun`, obj)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delGroupFun: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/DelGroupFun`, obj)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryPersonPermission: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getPermissionMgmt}/QryPersonPermission`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  qryEmp: (context, d) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getPermissionMgmt}/QryEmp?d=${d}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insPersonPermission: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postPermissionMgmt}/InsPersonPermission`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delPersonPermission: (context, rid) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getPermissionMgmt}/DelPersonPermission?rid=${rid}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
